import { cn } from '@/lib/utils'
import { priorityConfig } from '@/types/notes'
import type { PriorityLevel } from '@/types/conversation'

interface PriorityBadgeProps {
  priority?: PriorityLevel | null
  className?: string
}

export function PriorityBadge({ priority, className }: PriorityBadgeProps) {
  // Default to medium if no priority set
  const level = priority || 'medium'
  const config = priorityConfig[level]

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
        config.bgColor,
        config.color,
        className
      )}
    >
      {config.label}
    </span>
  )
}

export default PriorityBadge
